/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type TypeAddCart = 'new' | 'update';

@Injectable({
  providedIn: 'root'
})
export class CartPurchaseOrderService {
  data$: BehaviorSubject<any[]>;
  data: any;
  idProduct;
  constructor() {
    this.data = {};
    this.data$ = new BehaviorSubject<any[]>(Object.values(this.data));
  }
  getData(): any[] {
    return Object.values(this.data);
  }
  getData$() {
    return this.data$.asObservable();
  }
  setData$() {
    this.data$.next(this.getDataAsArr());
  }
  getDataAsArr() {
    return Object.values(this.data);
  }
  addItem(item) {
    this.idProduct = 0;
    if (item.productOfProviderId == undefined) {
      this.idProduct = item.id;
    } else {
      this.idProduct = item.productOfProviderId;
    }

    this.data[this.idProduct] = item;
    this.setData$();
  }
  removeItem(item) {
    this.idProduct = 0;
    if (item.productOfProviderId == undefined) {
      this.idProduct = item.id;
    } else {
      this.idProduct = item.productOfProviderId;
    }
    delete this.data[this.idProduct];
    this.setData$();
  }
  isCartEmpty() {
    return Object.keys(this.data).length === 0;
  }
  getAmountPurchase(): number {
    const amount = this.getDataAsArr().reduce((acc: any, current: any) => {
      return acc + current.quantityCart * current.unitPrice;
    }, 0);
    return amount as number;
  }

  emptyData() {
    this.data = {};
    this.data$.next(Object.values(this.data));
  }

  addGroup(items) {
    this.emptyData();
    for (const item of items) {
      const id = item.productOfProviderId;
      this.data[id] = item;
      this.setData$();
    }
  }

  addItemReception(item) {
    this.idProduct = 0;
    if (item.productOfProviderId == undefined) {
      this.idProduct = item.id;
    } else {
      this.idProduct = item.productOfProviderId;
    }

    this.data[this.idProduct] = item;
    this.setData$();
  }
}
